export default {"src":"/_next/static/media/my2cents.9f4a61c0.svg","height":48,"width":158};